import { applyThemeStylesToServiceTemplate } from './applyThemeStylesToServiceTemplate'
import { UpdateDynamicTextHandlerProps } from '@/types/editor'

export const updateServiceTemplates = (
  dynamicTextProps: UpdateDynamicTextHandlerProps,
): void => {
  const { elementProps, editorProps } = dynamicTextProps
  const { element } = elementProps
  const { selectedTheme } = editorProps

  const isServiceTemplate =
    element.attr('id') === 'service-information-template'

  if (!isServiceTemplate) {
    console.warn(
      'Service template missing id="service-information-template" attribute',
    )
    return
  }

  const currentContent = element.html()

  const styledContent = applyThemeStylesToServiceTemplate({
    html: currentContent,
    selectedTheme,
  })

  if (styledContent) {
    element.html(styledContent)
  }
}

export default updateServiceTemplates
